"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStopWatch = function useStopWatch() {
  var hoursInitial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var minutesInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var secondsInitial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
  var isAscending = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var _useState = (0, _react.useState)(secondsInitial),
      _useState2 = _slicedToArray(_useState, 2),
      seconds = _useState2[0],
      setSeconds = _useState2[1];

  var _useState3 = (0, _react.useState)(minutesInitial),
      _useState4 = _slicedToArray(_useState3, 2),
      minutes = _useState4[0],
      setMinutes = _useState4[1];

  var _useState5 = (0, _react.useState)(hoursInitial),
      _useState6 = _slicedToArray(_useState5, 2),
      hours = _useState6[0],
      setHours = _useState6[1];

  var _useState7 = (0, _react.useState)(hoursInitial * 3600 + minutesInitial * 60 + secondsInitial),
      _useState8 = _slicedToArray(_useState7, 2),
      delta = _useState8[0],
      setDelta = _useState8[1];

  var interval = null;
  (0, _react.useEffect)(function () {
    var moduleDelta = delta % 3600;
    setHours(Math.floor(delta / 3600));
    setMinutes(Math.floor(moduleDelta / 60));
    setSeconds(Math.floor(moduleDelta % 60));
  }, [delta]);

  var startTimer = function startTimer() {
    if (!interval) {
      var start = Date.now();
      interval = setInterval(function () {
        var dateDiff = Date.now() - start;
        var deltaCalculated = isAscending ? delta + Math.floor(dateDiff / 1000) : delta - Math.floor(dateDiff / 1000);
        setDelta(Math.ceil(deltaCalculated));
      }, delay);
    }
  };

  var stopTimer = function stopTimer() {
    clearInterval(interval);
    clear();
    interval = null;
  };

  var clear = function clear() {
    setHours(hoursInitial);
    setMinutes(minutesInitial);
    setSeconds(secondsInitial);
    setDelta(hoursInitial * 3600 + minutesInitial * 60 + secondsInitial);
  };

  var zeroPad = function zeroPad(value) {
    return value < 10 ? "0".concat(value) : value;
  };

  var fullFormat = function fullFormat() {
    var hoursShow = !hours ? 0 : hours;
    var minutesShow = !minutes ? 0 : minutes;
    var secondsShow = !seconds ? 0 : seconds;
    return '' + zeroPad(hoursShow) + ':' + zeroPad(minutesShow) + ':' + zeroPad(secondsShow);
  };

  return {
    seconds: seconds,
    minutes: minutes,
    hours: hours,
    fullFormat: fullFormat,
    start: startTimer,
    stop: stopTimer
  };
};

var _default = useStopWatch;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/StopWatch/CountDown/useStopWatch.js
// module id = 1919
// module chunks = 0